<div class="loading">

	<img class="gif" src="assets/img/gif-cargando.gif">
	
	<h4 class="message">Estamos procesando su solicitud</h4>

</div>

